import { render, staticRenderFns } from "./Serves.vue?vue&type=template&id=478c5e2c&"
import script from "./Serves.vue?vue&type=script&lang=js&"
export * from "./Serves.vue?vue&type=script&lang=js&"
import style0 from "./Serves.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports